import { render, staticRenderFns } from "./DetailDate.vue?vue&type=template&id=f89b2d4e&scoped=true&"
import script from "./DetailDate.vue?vue&type=script&lang=js&"
export * from "./DetailDate.vue?vue&type=script&lang=js&"
import style0 from "./DetailDate.vue?vue&type=style&index=0&id=f89b2d4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b2d4e",
  null
  
)

export default component.exports